import React from 'react'
import { Table } from 'reactstrap'
import { ODListColumnBuilder } from './columns/ODListColumnBuilder'
import { ODListableHeaders } from './ODListableHeader'
export function ODListablePaginatedTable(props) {
  var fields = props.fields,
    listableContext = props.listableContext,
    renderLoading = props.renderLoading,
    renderEmpty = props.renderEmpty,
    _a = props.tableClassName,
    tableClassName = _a === void 0 ? '' : _a,
    _b = props.onEvent,
    onEvent =
      _b === void 0
        ? function () {
            return null
          }
        : _b,
    eventParentContext = props.eventParentContext
  var rendererContext = React.useState(function () {
    return {
      onEvent: onEvent,
      parentContext: eventParentContext,
    }
  })[0]
  var buildFieldsDefinition = React.useCallback(
    function (fieldsDef) {
      return fieldsDef.map(function (f) {
        if (f instanceof ODListColumnBuilder) {
          return f.build(rendererContext)
        }
        return f
      })
    },
    [rendererContext]
  )
  var _c = React.useState(function () {
      return buildFieldsDefinition(fields)
    }),
    fieldsBuilt = _c[0],
    setFieldsBuilt = _c[1]
  React.useEffect(
    function () {
      setFieldsBuilt(buildFieldsDefinition(fields))
    },
    [setFieldsBuilt, buildFieldsDefinition, fields]
  )
  var _d = React.useContext(listableContext),
    state = _d.state,
    keyExtractor = _d.keyExtractor
  var loading = state.loading,
    list = state.list
  var rows = (function () {
    var colSpan = fields.length
    if (loading && renderLoading) {
      return React.createElement(
        'tr',
        { key: 'loading_row' },
        React.createElement('td', { colSpan: colSpan, className: 'text-center' }, renderLoading(state))
      )
    }
    if (list.length === 0) {
      return React.createElement(
        'tr',
        { key: 'empty_row' },
        React.createElement('td', { colSpan: colSpan, className: 'text-center' }, renderEmpty(state))
      )
    }
    return list.map(function (data) {
      var tds = fieldsBuilt.map(function (_a) {
        var id = _a.id,
          transform = _a.transform,
          _b = _a.className,
          className = _b === void 0 ? '' : _b,
          isHTML = _a.isHTML,
          tdStyle = _a.tdStyle,
          _c = _a.hide,
          hide = _c === void 0 ? false : _c
        if (hide) {
          return null
        }
        if (isHTML) {
          return React.createElement(
            'td',
            { key: id, className: className, style: tdStyle },
            React.createElement('div', {
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML: {
                __html: transform(data, state),
              },
            })
          )
        }
        return React.createElement('td', { key: id, className: className, style: tdStyle }, transform(data, state))
      })
      return React.createElement('tr', { key: 'tr-' + keyExtractor(data) }, tds)
    })
  })()
  return React.createElement(
    React.Fragment,
    null,
    React.createElement(
      Table,
      {
        responsive: true,
        striped: true,
        style: { marginTop: 0, borderBottom: '1px solid #c8ced2' },
        className: tableClassName,
      },
      React.createElement(
        'thead',
        null,
        React.createElement('tr', null, React.createElement(ODListableHeaders, { fields: fieldsBuilt }))
      ),
      React.createElement('tbody', null, rows)
    )
  )
}
//# sourceMappingURL=ODListablePaginationTable.js.map
